import * as EntryVisibility from './contents/EntryStatusTypes';
import * as CategoryVisibility from './category/CategoryVisibility';

/**
 * Entry && Category Visibility 체크
 */

// 공개
export const PUBLIC = 20;

// 비공개
export const CONNECTED = 5;

// 비공개
export const PRIVATE = 0;

// String 공개
export const STRING_PUBLIC = "public";

// String 친구공개
export const STRING_CONNECTED = "connected";

// String 비공개
export const STRING_PRIVATE = "private";

/**
 * 비공개
 * @param entryVisibility
 * @param categoryVisibility
 * @returns {boolean|*}
 */
export const isPrivate = (entryVisibility, categoryVisibility) => {
  return CategoryVisibility.isPrivate(categoryVisibility) || EntryVisibility.PRIVATE === entryVisibility
};


/**
 * 공개
 * @param entryVisibility
 * @param categoryVisibility
 * @returns {boolean}
 */
export const isPublic = (entryVisibility, categoryVisibility) => {
  return !isPrivate(entryVisibility, categoryVisibility);
};


/**
 * 친구공개
 * @param entryVisibility
 * @param categoryVisibility
 * @returns {*|boolean}
 */
export const isConnected = (entryVisibility, categoryVisibility) => {
  return CategoryVisibility.isPrivate(categoryVisibility) && EntryVisibility.FOLLOWED === entryVisibility;
};


/**
 * VisibilityString
 * @param entryVisibility
 * @param categoryVisibility
 * @returns {string}
 */
export const getString = (entryVisibility, categoryVisibility) => {

  // 비공개 체크
  if (isPrivate(entryVisibility, categoryVisibility)) return STRING_PRIVATE;

  // 친구공개 체크
  if (isConnected(entryVisibility, categoryVisibility)) return STRING_CONNECTED;

  // 그외 공개
  return STRING_PUBLIC;
};
